/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {doc, getDoc} from 'firebase/firestore';
import {db} from '../../../firebase';
import {toast} from 'react-toastify';
import {useParams} from 'react-router-dom';
import moment from 'moment';
import parse from 'html-react-parser';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

interface ReleaseProps {
  type: string,
  title: string,
  author: string,
  status: string,
  version: string,
  labels: [string],
  deployDate: Date,
  versionDate: Date,
  commitHash: string,
  htmlCompact: string,
  htmlComplete: string,
  versionDescription: string,
}

const Release = () => {
  const params = useParams<{ releaseId: '' }>();
  const [release, setRelease] = useState<ReleaseProps>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (loading) {
      const docRef = doc(db, 'releasesCreated', params.releaseId ?? '');

      const fetchData = async () => {
        const docSnap = await getDoc(docRef) as any;

        if (docSnap.exists()) {
          setRelease(docSnap.data());
          setLoading(false);
        } else {
          setLoading(false);
          toast.error('Não foi encontrado o release', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            progress: undefined,
          });
        }
      };

      fetchData();
    }
  }, [release, loading, params.releaseId]);

  if (loading) {
    return (
      <Grid
        container
        spacing={4}
        style={{
          justifyContent: 'center',
          alignContent: 'center',
          textAlign: 'center',
        }}
      >
        <Grid item xs={12}>
          <CircularProgress
            style={{
              padding: '20em 0',
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      style={{
        justifyContent: 'center',
      }}
    >
      {release &&
          <Grid
            item xs={12}
            style={{
              maxWidth: '600px',
            }}
          >
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Título: {release.title}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Autor: {release.author}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Hash do Commit: {release.commitHash}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Status: {release.status}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2">
                  Labels: {
                    release.labels &&
                    release.labels.map((label) =>
                      `${label}, `,
                    )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2">
                  Descrição: {release.versionDescription}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Data da Versão: {moment(release.versionDate).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Data do Deploy: {moment(release.deployDate).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Versão: {release.version}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Tipo: {release.type}
                </Typography>
              </Grid>
              {release.htmlCompact && (
                <>
                  <Grid item style={{paddingTop: '2em'}} xs={12}>
                    <Typography variant="subtitle2">
                      Versão Pública (iframe)
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {parse(release.htmlCompact)}
                  </Grid>
                </>
              )}
              {release.htmlComplete && (
                <>
                  <Grid item style={{paddingTop: '2em'}} xs={12}>
                    <Typography variant="subtitle2">
                      Versão Privada (email)
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {parse(release.htmlComplete)}
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
      }
    </Grid>

  );
};

export default Release;
